import {useMemo} from 'react'
import {PaginateModel} from './core/_models'

const PaginateRange = ({
  pagination,
  pageNumber = 7,
}: {
  pagination: PaginateModel
  pageNumber: number
}) => {
  const range = (start: number, end: number) => {
    let length = end - start + 1
    return Array.from({length}, (_, index) => index + start)
  }

  return useMemo(() => {
    const totalPageCount = pagination.total_pages
    const currentPage = pagination.page

    /*
      Case 1:
      If the number of pages is less than the page numbers we want to show in our
      PaginateWidget, we return the range [1..totalPageCount]
    */
    if (pageNumber >= totalPageCount) {
      return range(1, totalPageCount)
    }

    /*
      Case 2:
      Center the current page inside the visible range.
      We first calculate the tentative start and end indexes based on the
      maximum number of pages that we want to show.
    */
    const half = Math.floor(pageNumber / 2)
    let start = currentPage - half
    let end = start + pageNumber - 1

    /*
      Case 3:
      If the range exceeds the left boundary, shift it to start from page 1.
    */
    if (start < 1) {
      start = 1
      end = pageNumber
    }

    /*
      Case 4:
      If the range exceeds the right boundary, shift it back so that the last
      visible page is totalPageCount.
    */
    if (end > totalPageCount) {
      end = totalPageCount
      start = totalPageCount - pageNumber + 1
    }

    return range(start, end)
  }, [pagination, pageNumber])
}

export {PaginateRange}
